<template>
  <div class="scenario-container muzik-performer mk-container">
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <LayoutList title="演出者列表" type="performer" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs'
import LayoutList from '@/components/people/LayoutList'

export default {
  name: 'Performer',
  components: {
    Breadcrumbs,
    LayoutList
  },
  data() {
    return {
      breadcrumbs: this.$route.meta.breadcrumbs
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.muzik-performer {
  // padding: 0 $padding-lg-grid-x1 66px;
  padding-bottom: 66px;
  .breadcrumbs{
    padding: 24px 0;
  }
}

@media only screen and (min-width: 1440px) {
  //as default
}

@media only screen and (max-width: 1439.98px) {
  .muzik-performer {
    // padding: 0 $padding-md-grid-x1;
    padding-bottom: 66px;
  }
}

@media only screen and (max-width: 1023.98px) {
  .muzik-performer {
    // padding: 0 $padding-sm-grid-x1;
    padding-bottom: 66px;
  }
}

@media only screen and (max-width: 767.98px) {
  padding-bottom: 66px;
}

</style>
